import React, { Component } from 'react';
import UserService from '../service/userService';
import "../design/navigationBar.css";
import NavigationBar from '../components/navigationBar';
import AuthorizationHelper from '../helper/AuthorizationHelper';

export default class Index extends Component {

    constructor(props) {
        super(props);
        this.userService = new UserService();
        this.state = {
            myInfo: null
        }
        this.authorizationHelper = new AuthorizationHelper();


        this.authorizationHelper.checkAccessTokenAndRefresh();
    }

    async getMyInformation() {
        let result = await this.userService.getMe();

        if (result.status === 401) {
            this.setState({
                myInfo: null
            })

        }
        else {
            this.setState({
                myInfo: result
            })
        }
    }

    componentDidMount() {
        document.title = "Index";
        this.getMyInformation();
    }

    render() {
        return (
            <div>
                <NavigationBar props={this.props} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/index.js